"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaymentMethodName = exports.generateOrderLinkForEstApp = exports.generateOrderLinkForDistApp = exports.generateInvoiceLinkForEstApp = exports.generateInvoiceLinkForDistApp = exports.generateInvitationLink = exports.computeTaxedTotal = exports.computeSubTotal = exports.buildInvoiceNumberWithBeer = void 0;
var _config = _interopRequireDefault(require("../config"));
var _constants = require("../invoice/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const buildInvoiceNumberWithBeer = (invoice = {}, isCustomerInvoiceNumberingActive = false) => {
  const number = !!invoice.beer ? `${invoice.number}B` : invoice.number;
  if (isCustomerInvoiceNumberingActive) {
    return `${invoice.customer_id}-${number}`;
  }
  return number;
};
exports.buildInvoiceNumberWithBeer = buildInvoiceNumberWithBeer;
const generateInvitationLink = ({
  name = "",
  email = "",
  tabc_id = "",
  token = ""
}) => {
  const userName = name ? `name=${encodeURIComponent(name)}&` : "";
  const userEmail = email ? `email=${email.replaceAll(/\s/g, "")}&` : "";
  const userTabc = tabc_id ? `tabc_id=${tabc_id === null || tabc_id === void 0 ? void 0 : tabc_id.replaceAll(/\s/g, "")}&` : "";
  const userToken = token ? `token=${token}` : "";
  const link = `${_config.default.protocol}${_config.default.order_app_subdomain}.${_config.default.client_host}/signup?${userName}${userEmail}${userTabc}${userToken}`;
  return link;
};
exports.generateInvitationLink = generateInvitationLink;
const generateInvoiceLinkForDistApp = ({
  number,
  withText = false
}) => {
  if (!!withText) return `#${number} - ${_config.default.distributor_host}invoice/${number}`;
  return `${_config.default.distributor_host}invoice/${number}`;
};
exports.generateInvoiceLinkForDistApp = generateInvoiceLinkForDistApp;
const generateInvoiceLinkForEstApp = ({
  invoice,
  withText = false
}) => {
  if (!!withText) return `#${invoice.number} - ${_config.default.protocol}${_config.default.order_app_subdomain}.${_config.default.client_host}/invoice/${invoice.id}`;
  return `${_config.default.protocol}${_config.default.order_app_subdomain}.${_config.default.client_host}/invoice/${invoice.id}`;
};
exports.generateInvoiceLinkForEstApp = generateInvoiceLinkForEstApp;
const generateOrderLinkForEstApp = ({
  order
}) => {
  return `${_config.default.protocol}${_config.default.order_app_subdomain}.${_config.default.client_host}/order/${order.id}`;
};
exports.generateOrderLinkForEstApp = generateOrderLinkForEstApp;
const generateOrderLinkForDistApp = ({
  order_number
}) => {
  return `${_config.default.distributor_host}order/${order_number}`;
};

/**
 * Given a line item, if the item is taxable, it will add a 8.25% sales tax and return the tax amount
 * @param item
 * @param {boolean} item.taxable
 * @param {number} item.total
 * @return {number|number}
 */
exports.generateOrderLinkForDistApp = generateOrderLinkForDistApp;
const computeTaxedTotal = (item, taxRate) => {
  return item.taxable ? item.total * taxRate / 100 : 0;
};
exports.computeTaxedTotal = computeTaxedTotal;
const parseCurrency = amount => Number(parseFloat(amount).toFixed(2));
const computeSubTotal = ({
  price,
  qty
}) => parseCurrency(parseCurrency(price) * parseInt(qty));
exports.computeSubTotal = computeSubTotal;
const getPaymentMethodName = method => {
  switch (method) {
    case _constants.PaymentMethods.FINTECH:
      return 'Fintech';
    case _constants.PaymentMethods.CHECK:
      return 'Check';
    case _constants.PaymentMethods.PREPAID:
      return 'Prepaid';
    case _constants.PaymentMethods.CASH:
      return 'Cash';
    default:
      return 'Other';
  }
};
exports.getPaymentMethodName = getPaymentMethodName;